import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import BurgerMenuItemSecondLevel from "./BurgerMenuItemSecondLevel";

const BurgerMenuItem = ({
                          title,
                          url,
                          subtree,
                          activeLevel,
                          levelsHandler,
                          backBtnHandler,
                          setSecondLevelTitle,
                          setThirdLevelTitle, backButtonLabel, attributes,
                          obfuscate, obfuscateDataUrl, classStyle, disableForLanguage
                        }) => {
  const [secondLevelIsOpen, setSecondLevelIsOpen] = useState(false);

  useEffect(() => {
    if (activeLevel === 'first') {
      const timer = setTimeout(() => setSecondLevelIsOpen(false), 500);
      return () => clearTimeout(timer);
    }
  }, [activeLevel]);

  const openMenuSecondLevel = () => {
    levelsHandler('second');
    setSecondLevelIsOpen(true);
    setSecondLevelTitle(title);
  };

  if (disableForLanguage) return null;

  const hasChildren = subtree && Object.keys(subtree).length > 0;
  const classFromBO = attributes?.class || '';
  const targetFromBO = attributes?.target || '';

  const renderLink = () => {
    if (obfuscate && !hasChildren) {
      return (
        <span className={cn(classFromBO, 'obfuscate')} data-link={obfuscateDataUrl} data-target={targetFromBO}>
          {title}
        </span>
      );
    }
    if (hasChildren) {
      return <span className={cn(classFromBO, 'hasChildren')} onClick={openMenuSecondLevel}>{title}</span>;
    }
    return <a href={url} className={cn(classFromBO)} target={targetFromBO}>{title}</a>;
  };

  return (
    <div className={cn('mobile-menu__item', classStyle)}>
      {renderLink()}
      {secondLevelIsOpen && (
        <div className="mobile-menu__second-level">
          <div className="mobile-menu__back-btn" onClick={() => levelsHandler('first')}>
            {backButtonLabel}
          </div>
          {Object.keys(subtree).map((key) => (
            <BurgerMenuItemSecondLevel
              {...subtree[key]}
              key={key}
              activeLevel={activeLevel}
              levelsHandler={levelsHandler}
              backBtnHandler={backBtnHandler}
              setThirdLevelTitle={setThirdLevelTitle}
              backButtonLabel={backButtonLabel}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BurgerMenuItem;
